import { createAsyncThunk } from "@reduxjs/toolkit";
import apiBilling from "@/lib/api/billing";
import { IUserSlice, TAddress } from "@/redux/slices/user/types";

export const getAddresses = createAsyncThunk(
  "user/getAddresses",
  apiBilling.getAddresses
);

const pending = (state: IUserSlice) => {
  state.user.addresses.loading = true;
};

const fulfilled = (state: IUserSlice, { payload }: { payload: TAddress[] }) => {
  state.user.addresses.loading = false;
  state.user.addresses.options = payload;
};

const rejected = (state: IUserSlice) => {
  state.user.addresses.loading = false;
  state.user.addresses.options = [];
};

export default {
  action: getAddresses,
  pending,
  fulfilled,
  rejected,
};
